import React, { Component } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { injectIntl } from 'react-intl';
// style
import s from './AdminDashboard.css';
// helper
import messages from '../../../locale/messages';
// components
import AdminDashboardUserCard from './AdminDashboardUserCard';
//image
import userIcon from '../../../../public/Icons/adminUserIcon.png';
import deliverIcon from '../../../../public/Icons/adminDeliveryIcon.png';
import storeIcon from '../../../../public/Icons/storeAdminIcon.png';
import orderIcon from '../../../../public/Icons/orderIcondashboard.png';
import earnIcon from '../../../../public/Icons/earnIconDashboard.png';

export class AdminDashboard extends Component {
    render() {
        const { formatMessage } = this.props.intl;
        const { orders, earnings, users, drivers, shops, toCurrency } = this.props;
        let boxOneBg = 'boxOneBg';
        let boxTwoBg = 'boxTwoBg';
        let boxThreeBg = 'boxThreeBg';
        let boxFour = 'boxFour'

        return (
            <div className={s.paddingLeftRight}>
                <Container fluid>
                    <Row>
                        <AdminDashboardUserCard
                            data={users}
                            heading={formatMessage(messages.totalUsers)}
                            link={'/siteadmin/users'}
                            boxOneBg={boxOneBg}
                            hideSection
                            icon={userIcon}
                        />
                        <AdminDashboardUserCard
                            data={drivers}
                            heading={formatMessage(messages.totalDrivers)}
                            link={'/siteadmin/drivers'}
                            hideSection
                            boxTwoBg={boxTwoBg}
                            icon={deliverIcon}
                        />
                        <AdminDashboardUserCard
                            data={shops}
                            heading={formatMessage(messages.totalStores)}
                            link={'/siteadmin/store/list'}
                            hideSection
                            icon={storeIcon}
                            boxThreeBg={boxThreeBg}
                        />
                        <AdminDashboardUserCard
                            data={orders}
                            heading={formatMessage(messages.bookings)}
                            link={'/siteadmin/bookings'}
                            hideBox
                            boxFour={boxFour}
                            largeBox={true}
                            iconTwo={orderIcon}
                        />
                        <AdminDashboardUserCard
                            data={earnings}
                            heading={formatMessage(messages.earnings)}
                            link={'/siteadmin/admin-earnings'}
                            displayAmount={true}
                            largeBox={true}
                            toCurrency={toCurrency}
                            hideBox
                            boxFour={boxFour}
                            iconTwo={earnIcon}
                        />
                    </Row>
                </Container>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    toCurrency: state.siteSettings && state.siteSettings.data && state.siteSettings.data.currency
});

const mapDispatchToProps = {};

export default injectIntl(withStyles(s)(connect(mapStateToProps, mapDispatchToProps)(AdminDashboard)));